<div class="compact-building-card card">
  <ng-container *ngIf="hasCover; then thumbnailView else placeholderView"></ng-container>
  <h5 class="title">{{building.label || building.reference }}</h5>
  <div class="notification">
    <div >
      {{ model.notificationCount }}
    </div>
  </div>
  <strong class="business-ID">{{ building.reference }}</strong>
  <address>
    <i class="fas fa-map-marker"></i>
    {{ multilineAddress }}
  </address>
</div>

<ng-template #placeholderView>
  <figure class="thumbnail placeholder">
    <i class="fas fa-lg fa-building"></i>
  </figure>
</ng-template>

<ng-template #thumbnailView>
  <figure class="thumbnail">
    <img [src]="cover" />
  </figure>
</ng-template>
